module.exports = __webpack_public_path__ + "img/protect-privacy-dark.1be6f978.svg";